import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { CsrWebApiService } from '../../../csr-web-api.service';

@Component({
  selector: 'app-reset-password-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink],
  templateUrl: './reset-password-page.component.html'
})
export class ResetPasswordPageComponent {
  private readonly fb = inject(FormBuilder);
  private readonly api = inject(CsrWebApiService);
  private readonly route = inject(ActivatedRoute);

  submitting = false;
  message = '';
  success = false;

  readonly form = this.fb.nonNullable.group({
    email: [this.route.snapshot.queryParamMap.get('email') ?? '', [Validators.required, Validators.email]],
    token: [this.route.snapshot.queryParamMap.get('token') ?? '', [Validators.required]],
    newPassword: ['', [Validators.required]]
  });

  async submit(): Promise<void> {
    if (this.form.invalid || this.submitting) {
      return;
    }

    this.submitting = true;
    this.message = '';
    try {
      await firstValueFrom(this.api.resetPassword(this.form.getRawValue()));
      this.success = true;
      this.message = 'Password reset successful.';
      this.form.controls.newPassword.reset();
    } catch {
      this.success = false;
      this.message = 'Password reset failed.';
    } finally {
      this.submitting = false;
    }
  }
}
